export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'action', name: '动作', icon: 'ri-fire-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line' },
  { slug: 'daily', name: '日常', icon: 'ri-sun-line' },
  { slug: 'historical', name: '古风', icon: 'ri-ancient-gate-line' },
];

export const comics = [
  {
    id: 1,
    title: '重生之都市仙尊',
    author: '金泰亨',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20style%2C%20urban%20fantasy%20immortal%20cultivator%20in%20modern%20city%2C%20dramatic%20lighting%2C%20manhwa%20illustration%20with%20clean%20lines%2C%20vibrant%20colors%2C%20manga%20style%20character%20design%2C%20professional%20webcomic%20cover%20quality%2C%20dynamic%20pose%2C%20soft%20gradient%20background&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '曾经叱咤仙界的一代仙尊，在渡劫失败后意外重生回到都市少年时代。带着前世记忆和修为的他，决定在这一世活出不一样的精彩人生。面对曾经的敌人与机遇，他将如何改写命运？',
    rating: 9.6,
    views: '325.6万',
    chapters: 187,
    status: '连载中',
    tags: ['重生', '修仙', '都市', '爽文'],
    updatedAt: '2026-08-03',
    featured: true,
    trending: 1,
  },
  {
    id: 2,
    title: '社长的小娇妻',
    author: '李智恩',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%20art%2C%20elegant%20CEO%20couple%20in%20romantic%20office%20setting%2C%20soft%20pastel%20color%20palette%2C%20manhwa%20style%20beautiful%20characters%2C%20gentle%20atmosphere%2C%20professional%20webcomic%20illustration%2C%20delicate%20linework%2C%20dreamy%20lighting&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '普通职场女孩林小暖意外嫁给了冷酷社长韩景琛，本以为只是一场交易婚姻，却在相处中日久生情。当隐藏的身世之谜逐渐浮出水面，两人的感情将面临怎样的考验？',
    rating: 9.4,
    views: '512.8万',
    chapters: 234,
    status: '连载中',
    tags: ['恋爱', '总裁', '契约婚姻', '甜宠'],
    updatedAt: '2026-08-04',
    featured: true,
    trending: 2,
  },
  {
    id: 3,
    title: '暗黑格斗者',
    author: '朴正洙',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20action%20webtoon%20cover%20art%2C%20intense%20fighting%20scene%20with%20martial%20artist%2C%20dark%20underground%20arena%20atmosphere%2C%20dramatic%20dynamic%20composition%2C%20manhwa%20style%20muscular%20fighter%2C%20bold%20colors%20and%20sharp%20lines%2C%20professional%20webcomic%20quality&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '在黑暗的地下格斗世界，少年陈浩凭借一双铁拳杀出一条血路。为了寻找失踪的妹妹，他不得不参加最危险的地下格斗大赛。每一场比赛都是生死之战！',
    rating: 9.2,
    views: '198.3万',
    chapters: 156,
    status: '连载中',
    tags: ['格斗', '热血', '复仇', '生存'],
    updatedAt: '2026-08-02',
    featured: true,
    trending: 3,
  },
  {
    id: 4,
    title: '异世界美食之旅',
    author: '崔美娜',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20webtoon%20cover%20art%2C%20magical%20food%20and%20cooking%20in%20fantasy%20world%2C%20colorful%20whimsical%20illustration%2C%20cute%20manhwa%20style%20chef%20character%2C%20warm%20cozy%20atmosphere%2C%20detailed%20food%20art%2C%20professional%20webcomic%20quality&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '天才厨师柳星儿意外穿越到异世界，发现这里的美食文化极其落后。凭借精湛厨艺，她决定在这个世界开启一场美食革命，用料理征服异世界居民的心！',
    rating: 9.5,
    views: '287.4万',
    chapters: 201,
    status: '连载中',
    tags: ['异世界', '美食', '治愈', '冒险'],
    updatedAt: '2026-08-04',
    featured: false,
    trending: 4,
  },
  {
    id: 5,
    title: '办公室喜剧人',
    author: '姜东元',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20webtoon%20cover%20art%2C%20funny%20office%20workers%20in%20hilarious%20situations%2C%20exaggerated%20expressions%2C%20bright%20playful%20colors%2C%20manhwa%20style%20humorous%20illustration%2C%20cartoonish%20vibe%2C%20professional%20webcomic%20quality&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '职场菜鸟张晓明的爆笑办公室生存日记！奇葩同事、无厘头上司、各种令人啼笑皆非的职场日常，每一话都能让你笑到肚子痛。打工人必看解压神作！',
    rating: 9.0,
    views: '456.1万',
    chapters: 312,
    status: '连载中',
    tags: ['搞笑', '职场', '日常', '解压'],
    updatedAt: '2026-08-03',
    featured: false,
    trending: 5,
  },
  {
    id: 6,
    title: '迷雾追踪',
    author: '尹恩惠',
    category: 'thriller',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20webtoon%20cover%20art%2C%20mysterious%20detective%20in%20foggy%20city%20night%2C%20dark%20moody%20atmosphere%2C%20psychological%20suspense%2C%20manhwa%20style%20noir%20illustration%2C%20shadowy%20figures%2C%20tense%20composition%2C%20professional%20webcomic%20quality&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '连环杀人案震动全城，女刑警队长林素妍在追查真相的过程中，发现所有线索都指向了十年前的一桩悬案。凶手就在身边，谁才是真正的幕后黑手？',
    rating: 9.7,
    views: '267.9万',
    chapters: 98,
    status: '连载中',
    tags: ['悬疑', '推理', '犯罪', '心理'],
    updatedAt: '2026-08-01',
    featured: true,
    trending: 6,
  },
  {
    id: 7,
    title: '星光眼泪',
    author: '宋慧乔',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20drama%20webtoon%20cover%20art%2C%20emotional%20story%20of%20star-crossed%20lovers%20under%20starlit%20sky%2C%20melancholic%20beautiful%20atmosphere%2C%20manhwa%20style%20sad%20but%20beautiful%20illustration%2C%20soft%20watercolor%20effect%2C%20professional%20webcomic%20quality&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '身患绝症的女孩与失明钢琴家之间催泪的爱情故事。在生命最后的时光里，他们用音乐和爱温暖彼此。当星光洒落，眼泪化作最美的记忆。',
    rating: 9.8,
    views: '623.5万',
    chapters: 145,
    status: '已完结',
    tags: ['爱情', '悲剧', '音乐', '治愈'],
    updatedAt: '2026-07-28',
    featured: true,
    trending: 7,
  },
  {
    id: 8,
    title: '猫咪咖啡厅',
    author: '金秀贤',
    category: 'daily',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20slice%20of%20life%20webtoon%20cover%20art%2C%20cozy%20cat%20cafe%20with%20cute%20cats%20and%20warm%20interiors%2C%20wholesome%20healing%20atmosphere%2C%20soft%20pastel%20colors%2C%20manhwa%20style%20adorable%20illustration%2C%20relaxing%20vibe%2C%20professional%20webcomic%20quality&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '辞去高压工作后，小悠开了一家猫咪咖啡厅。在这里，她遇到了各种各样的人和猫，每个顾客都带着自己的故事。温暖治愈的日常，让每一天都闪闪发光。',
    rating: 9.3,
    views: '189.7万',
    chapters: 267,
    status: '连载中',
    tags: ['治愈', '日常', '猫咪', '温馨'],
    updatedAt: '2026-08-04',
    featured: false,
    trending: 8,
  },
  {
    id: 9,
    title: '大燕风华录',
    author: '郑智薰',
    category: 'historical',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20historical%20webtoon%20cover%20art%2C%20ancient%20palace%20drama%20with%20elegant%20traditional%20hanbok%20characters%2C%20rich%20golden%20and%20red%20color%20scheme%2C%20manhwa%20style%20historical%20romance%2C%20elaborate%20costume%20details%2C%20professional%20webcomic%20quality&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '大燕王朝风云变幻，女扮男装的世子妃周瑾瑜在朝堂之上运筹帷幄。权谋、宫斗、家国情仇，她将在这乱世之中书写属于自己的传奇。',
    rating: 9.4,
    views: '345.2万',
    chapters: 178,
    status: '连载中',
    tags: ['古风', '权谋', '女强', '宫斗'],
    updatedAt: '2026-08-03',
    featured: false,
    trending: 9,
  },
  {
    id: 10,
    title: '末日生存法则',
    author: '崔胜贤',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20post%20apocalyptic%20webtoon%20cover%20art%2C%20survivors%20in%20destroyed%20city%20fighting%20monsters%2C%20dark%20gritty%20atmosphere%2C%20manhwa%20style%20action%20scene%2C%20dramatic%20lighting%20and%20dynamic%20composition%2C%20professional%20webcomic%20quality&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '丧尸病毒爆发后的第三年，幸存者们在废墟中挣扎求生。前特种兵韩烈带领小队在末日世界里寻找传说中的安全区，却发现真正的威胁并非丧尸，而是人心。',
    rating: 9.1,
    views: '278.6万',
    chapters: 134,
    status: '连载中',
    tags: ['末日', '丧尸', '生存', '冒险'],
    updatedAt: '2026-08-02',
    featured: false,
    trending: 10,
  },
  {
    id: 11,
    title: '甜蜜的谎言',
    author: '林允儿',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%20art%2C%20young%20couple%20in%20cherry%20blossom%20spring%20scene%2C%20sweet%20bittersweet%20love%20story%2C%20soft%20pink%20and%20white%20color%20palette%2C%20manhwa%20style%20beautiful%20romantic%20illustration%2C%20professional%20webcomic%20quality&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '为了守护暗恋对象，韩小朵编织了一个又一个善意的谎言。当谎言越滚越大，她该如何收场？一场始于谎言的爱情，最终能否收获真心？',
    rating: 9.2,
    views: '156.3万',
    chapters: 89,
    status: '连载中',
    tags: ['恋爱', '校园', '甜宠', '青春'],
    updatedAt: '2026-08-04',
    featured: false,
    trending: 11,
  },
  {
    id: 12,
    title: '魔王学院',
    author: '金宇彬',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20webtoon%20cover%20art%2C%20demon%20king%20academy%20magic%20school%20setting%2C%20dark%20fantasy%20aesthetic%2C%20manhwa%20style%20magical%20characters%2C%20mysterious%20atmosphere%20with%20glowing%20elements%2C%20professional%20webcomic%20quality&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '被所有人认为是最弱的学生，却在入学测试中展现出毁灭级魔力。从废物到最强，主角在魔王学院中一步步揭开自己的真实身份。学院最强争夺战，一触即发！',
    rating: 9.5,
    views: '489.7万',
    chapters: 223,
    status: '连载中',
    tags: ['奇幻', '学院', '逆袭', '热血'],
    updatedAt: '2026-08-03',
    featured: true,
    trending: 12,
  },
];

export const siteInfo = {
  name: '韩漫星球',
  tagline: '海量正版韩漫资源，畅享安心阅读体验',
  description: '韩漫星球是领先的韩国漫画在线观看平台，拥有海量正版韩漫资源。我们致力于为用户提供合法、安全、高品质的韩漫阅读体验，涵盖恋爱、动作、奇幻、搞笑、悬疑等丰富类型。',
  keywords: '韩漫网站,韩国漫画在线观看平台,下拉式韩漫,海量正版韩漫资源网址',
  domain: 'https://manhwaplanet.com',
  email: 'contact@manhwaplanet.com',
  phone: '400-888-6688',
  address: '北京市朝阳区望京SOHO T1-2208',
  social: {
    weibo: 'https://weibo.com/manhwaplanet',
    wechat: '韩漫星球',
  },
};

export const faqs = [
  {
    question: '韩漫星球的漫画都是正版授权的吗？',
    answer: '是的，韩漫星球平台上的所有漫画内容均获得正版授权。我们与韩国多家知名漫画出版机构和创作者建立了长期稳定的合作关系，确保每一部作品都经过合法授权，为用户提供安心的阅读环境。',
  },
  {
    question: '如何在海量资源中找到我喜欢的漫画？',
    answer: '您可以通过首页的分类导航按恋爱、动作、奇幻等类型筛选漫画，也可以使用搜索功能直接查找作品名称或作者。我们还提供了热门排行、编辑推荐等板块，帮助您发现优质内容。',
  },
  {
    question: '韩漫星球支持哪些阅读方式？',
    answer: '韩漫星球采用适合手机阅读的下拉式韩漫排版，完美适配移动端和桌面端浏览器。您可以在任何设备上流畅阅读，无需下载额外应用，打开浏览器即可享受沉浸式阅读。',
  },
  {
    question: '平台上的漫画更新频率如何？',
    answer: '我们与版权方保持紧密同步，连载作品通常每周更新1-2话，部分热门作品可做到每日更新。您可以在首页"最新更新"板块第一时间看到最新上架的内容。',
  },
  {
    question: '在韩漫星球阅读需要付费吗？',
    answer: '我们提供部分免费试读章节，让用户可以先体验再决定。对于付费内容，我们采用合理的定价策略，并定期推出优惠活动，让更多用户能够以实惠的价格享受正版韩漫。',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '小雨',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20cute%20young%20woman%20profile%20picture%2C%20soft%20natural%20lighting%2C%20warm%20tone%2C%20portrait%20photography%2C%20simple%20clean%20background&width=200&height=200&seq=avatar-01&orientation=squarish',
    comment: '终于找到一个全是正版韩漫的平台了！画质超清晰，翻译也很用心，再也不用担心看到各种水印盗版了。推荐给了好多朋友！',
    rating: 5,
  },
  {
    id: 2,
    name: '阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20young%20man%20profile%20picture%2C%20friendly%20smile%2C%20warm%20natural%20lighting%2C%20casual%20portrait%20photography%2C%20simple%20clean%20background&width=200&height=200&seq=avatar-02&orientation=squarish',
    comment: '下拉式阅读体验太棒了，在手机上也能流畅看漫画。更新速度也很快，追的几部热门作品基本每周都能看到新内容。',
    rating: 5,
  },
  {
    id: 3,
    name: '小美',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20beautiful%20young%20woman%20portrait%2C%20gentle%20expression%2C%20soft%20natural%20lighting%2C%20warm%20tone%20photography%2C%20simple%20clean%20background&width=200&height=200&seq=avatar-03&orientation=squarish',
    comment: '分类很全面，从恋爱甜宠到悬疑推理应有尽有。编辑推荐的质量真的高，帮我发现了好几部宝藏韩漫！',
    rating: 5,
  },
];

export const stats = [
  { label: '正版漫画', value: '10,000+' },
  { label: '累计用户', value: '500万+' },
  { label: '合作作者', value: '3,000+' },
  { label: '日均更新', value: '200+话' },
];